module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("What It Used to Be Like")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "9781429902687.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "margin-left": "5%",
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781429902687_pt01#pt01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1950s")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781429902687_ch01#ch01"
    }
  }, [_vm._v("1 Spudnuts and Roses")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781429902687_ch02#ch02"
    }
  }, [_vm._v("2 Love Letters")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 To Church We Went")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Young, Married, with Children")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 A Town Called Paradise")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Along the Way at Chico State")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "margin-left": "5%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_pt02#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1960s")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Eureka")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Arcata")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Iowa City")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Sacramento")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Palo Alto, Israel, Paris, Hollywood")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "margin-left": "5%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_pt03#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1970s")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Writing, Teaching, Drinking")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 That August")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Maelstrom")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Will You Please Be Quiet, Please?”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Twisted Fork in the Road")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Parting and Apart")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "margin-left": "5%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_pt04#pt04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1980s")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Nobody Knows")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "margin-left": "10%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Always")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "margin-left": "5%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chronology: Raymond Carver,")]), _vm._v(" 1938–88")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "margin-left": "5%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_bm02#bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Selected Works of Raymond Carver")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "margin-left": "5%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ack01#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "margin-left": "5%",
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781429902687_ind01#ind01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Index")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c308fac6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429902687_con01.vue
// module id = 72
// module chunks = 0